var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import clsx from 'clsx';
import React from 'react';
import { capitalize } from '@material-ui/core/utils';
import { makeStyles } from '@material-ui/core/styles';
import { CircularProgress } from '@material-ui/core';
// ----------------------------------------------------------------------
const useStyles = makeStyles((theme) => ({
    colorInfo: { color: theme.palette.info.main },
    colorSuccess: { color: theme.palette.success.main },
    colorWarning: { color: theme.palette.warning.main },
    colorError: { color: theme.palette.error.main }
}));
export const MCircularProgress = (_a) => {
    var { color = 'primary', className } = _a, other = __rest(_a, ["color", "className"]);
    const classes = useStyles();
    if (color === 'inherit' || color === 'primary' || color === 'secondary') {
        return React.createElement(CircularProgress, Object.assign({ color: color, className: className }, other));
    }
    return (React.createElement(CircularProgress, Object.assign({ className: clsx({
            [classes[`color${capitalize(color)}`]]: color
        }, className) }, other)));
};
//# sourceMappingURL=MCircularProgress.js.map